import { SimpleEntityGrid } from "src/app/components/grid/SimpleEntityGrid";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { PageTitle, usePageData } from "src/_metronic/layout/core/PageData";
import useLibraryGridColumns from "./useLibraryGridColumns";
import useLibraryGridActions from "./useLibraryGridActions";
import { Order, UpsertOrderDTOSchema } from "src/app/types/orders/order";

import { ContentTransport } from "src/app/transports/content";
import { PublishOnContainer, ViewTextLibraryFormContainer } from "src/app/containers";
import { OrderTransport } from "src/app/transports/order";
import useLibraryToolbarButtons from "./useLibraryToolbarButtons";

const LibraryGrid = () => {
    const { formatMessage } = useIntl();
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [selectedRows, setSelectedRows] = useState<Array<Order>>([]);
    const [orderToUpdateGrid, setValueToUpdateGrid] = useState(false);
    const { setPageToolbarLinks } = usePageData();
    const handlePublishOnAction = (obj: any) => {
        setSelectedRows(obj.selectedRows);
        setShowModal(true);
    };
    const handlerValueToUpdateGrid = (update: boolean) => {
        setValueToUpdateGrid(update);
    };
    const toolActionsButton = useLibraryToolbarButtons(handlePublishOnAction);
    const handleClose = () => {
        setShowModal(false);
    };

    const gridColumns = useLibraryGridColumns();
    const actions = useLibraryGridActions();

    useEffect(() => {
        setPageToolbarLinks([]);
    }, [location]);
    return (
        <>
            <PageTitle>{formatMessage({ id: "library.title" })}</PageTitle>
            <SimpleEntityGrid
                columns={gridColumns}
                actions={actions}
                toolbarButtonAction={toolActionsButton}
                viewTextFormBodyContainer={ViewTextLibraryFormContainer}
                saveHandler={ContentTransport.save}
                entityName={formatMessage({ id: "common.entity.online" })}
                validationSchema={UpsertOrderDTOSchema}
                orderToUpdateGrid={orderToUpdateGrid}
                listHandler={OrderTransport.listLibrary}
                toggleActiveHandler={ContentTransport.toggleActive}
                formTransformer={ContentTransport.formTransformer}
                formBody={() => <></>}
            />
            <PublishOnContainer
                selectedRows={selectedRows}
                handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                handleClose={handleClose}
                showModal={showModal}
            />
        </>
    );
};

export default LibraryGrid;
